import { useMemo } from 'react';
import { useIoContext } from '~/contexts';
import { ContactModel } from '~/models/ContactModel';
import { useContacts } from '../queries/useContacts';
import { QueryKeys } from '../queryKeys';
import { useQueryState } from '../useQueryState';
const EMPTY_CONTACTS_MAP = {};
export function useContactsMap(vendorId) {
    var _ref, _ref1;
    const { contacts, isLoading, error, refresh } = useContacts();
    const { getNow } = useIoContext();
    const sampleContactPlaceholder = useMemo(()=>ContactModel.makeSample({
            createdAt: getNow(),
            vendorId
        }), [
        vendorId,
        contacts
    ]);
    const { data: contactsMapData } = useQueryState({
        queryKey: [
            QueryKeys.ContactsMap,
            vendorId,
            contacts
        ],
        queryFn: async ()=>{
            const contactsMap = {};
            let sampleContact = sampleContactPlaceholder;
            for(let i = 0; i < contacts.length; i++){
                const contact = contacts[i];
                if (contact.isSample()) {
                    sampleContact = contact;
                } else {
                    contactsMap[contact.id()] = contact;
                }
            }
            return {
                contactsMap,
                sampleContact
            };
        },
        cacheTime: 1 * 60 * 1000
    });
    return {
        contacts,
        contactsMap: (_ref = contactsMapData === null || contactsMapData === void 0 ? void 0 : contactsMapData.contactsMap) !== null && _ref !== void 0 ? _ref : EMPTY_CONTACTS_MAP,
        sampleContact: (_ref1 = contactsMapData === null || contactsMapData === void 0 ? void 0 : contactsMapData.sampleContact) !== null && _ref1 !== void 0 ? _ref1 : sampleContactPlaceholder,
        isLoading,
        error,
        fetchContacts: refresh
    };
}
